import React, { useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Button from "@/components/actions/Button";
import { ArrowRightIcon } from "@heroicons/react/outline";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import AnchorChip from "@/components/lib/AnchorChip";
import * as Text from "@/components/text";

export default function ProjectHistory({ data }) {
  const flickingRef = useRef(null);
  const [indexFlicking, setIndexFlicking] = useState(0);
  const handleChangeIndex = (index) => {
    flickingRef.current.moveTo(index);
  };

  return (
    <div className="amb-container my-8 ">
      <div className="pb-6 pt-8 md:pb-8 md:pt-10">
        <Text.Headline
          as="p"
          className="text-center text-[24px] font-light md:text-[32px] lg:text-[40px]"
        >
          Histórico de proyectos
        </Text.Headline>
      </div>
      <div className="w-full">
        {data.length >= 2 && (
          <Flicking
            ref={flickingRef}
            moveType="freeScroll"
            className="pb-6 md:py-0 md:pb-8"
            align="center"
          >
            {data?.map((item, i) => (
              <div
                key={i}
                className="px-0.5 "
                onClick={() => {
                  setIndexFlicking(i);
                  handleChangeIndex(i);
                }}
              >
                <AnchorChip active={indexFlicking === i}>
                  {item?.title}
                </AnchorChip>
              </div>
            ))}
          </Flicking>
        )}
      </div>
      <div className="flex flex-col justify-center md:flex-row md:justify-between">
        <div className="flex w-full items-center justify-center">
          <Image
            className="w-[184px] md:w-[256px] lg:w-[381px]"
            width={381}
            height={533}
            alt="logo"
            src={data[indexFlicking]?.image?.data?.attributes?.url}
          ></Image>
        </div>
        <div className="flex h-full flex-col items-center justify-center text-center md:w-full md:items-start md:justify-start md:text-start">
          <div className="mt-10 md:mt-0">
            <Text.Headline className="text-[28px] md:text-[32px] lg:text-[36px]">
              {data[indexFlicking]?.title}
            </Text.Headline>
          </div>
          <div className="mt-2 w-full">
            <Text.Headline className="text-[20px] md:text-[16px] lg:text-[18px]">
              {data[indexFlicking].subtitle}
            </Text.Headline>
          </div>
          <div className="mt-4">
            <Text.Headline className="text-[18px] font-normal md:text-[16px] lg:text-[18px]">
              {data[indexFlicking]?.description}
            </Text.Headline>
          </div>
          <Link
            href={`blog/${data[indexFlicking]?.entrada?.data?.attributes?.slug}`}
            passHref
            className="mt-8 w-full"
          >
            <Button
              className="w-full font-semibold md:w-fit md:px-16"
              trailingIcon={<ArrowRightIcon />}
              color="white-on-black"
              label="Ver más detalles"
            ></Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
